import { Accordion, AccordionSummary, AccordionDetails, alpha } from "@mui/material";
import { styled } from '@mui/material/styles';

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  marginBottom: '8px',
  '&:before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: '8px 0',
  },
  borderRadius: '8px !important',
  overflow: 'hidden',
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
}));

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.05),
  '&.Mui-expanded': {
    minHeight: '48px',
  },
  '& .MuiAccordionSummary-content': {
    margin: '8px 0',
    '&.Mui-expanded': {
      margin: '8px 0',
    },
  },
}));

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: '16px',
  backgroundColor: theme.palette.background.paper,
})); 